export default __webpack_public_path__ + "static/media/file.39455d05.png";